import { useEffect, useState } from "react";

interface ToastPayload {
  message: string;
  icon: string;
}

export function showToast(message: string, icon = "ri-information-line") {
  window.dispatchEvent(
    new CustomEvent<ToastPayload>("app-toast", { detail: { message, icon } })
  );
}

export default function ToastHost() {
  const [toast, setToast] = useState<ToastPayload | null>(null);

  useEffect(() => {
    let timer: number | undefined;
    const handler = (e: Event) => {
      const detail = (e as CustomEvent<ToastPayload>).detail;
      setToast(detail);
      window.clearTimeout(timer);
      timer = window.setTimeout(() => setToast(null), 2200);
    };
    window.addEventListener("app-toast", handler);
    return () => {
      window.removeEventListener("app-toast", handler);
      window.clearTimeout(timer);
    };
  }, []);

  if (!toast) return null;

  return (
    <div className="fixed left-1/2 bottom-24 md:bottom-10 z-[100] -translate-x-1/2">
      <div className="animate-fade-up flex items-center gap-2 rounded-full bg-foreground-950 px-5 py-3 text-sm text-background-50 shadow-lg">
        <i className={`${toast.icon} text-primary-400 text-base`}></i>
        <span className="font-label">{toast.message}</span>
      </div>
    </div>
  );
}